<template>
  <div class="p-5">

    <h1>Time picker</h1>

    <el-time-select value="14:00" />
    <el-time-select v-model="test_time1" />
    <pre class="mini-pre">test_time1: {{test_time1}}</pre>

    <el-time-picker v-model="test_time2"
      arrow-control
      size="fat"
      popper-class="gp-custom-time-picker"
      value-format="HH:mm"
      :picker-options="{
        format: 'HH:mm'
      }"/>
    <pre class="mini-pre">test_time2: {{test_time2}}</pre>

    <el-time-picker v-model="test_time3"
      size="fat"
      value-format="HH:mm"
      :picker-options="{
        format: 'HH:mm A'
      }"/>
    <pre class="mini-pre">test_time3: {{test_time3}}</pre>

    <vue-time-picker v-model="test_time4" format="HH:mm" :minute-interval="5" />
    <vue-time-picker :value="{ HH: '17', mm: '15' }" format="HH:mm" :minute-interval="15" />
    <pre class="mini-pre">test_time4: {{test_time4}}</pre>

    <hr />
    <h1>Misc</h1>

    <el-card class="m-4 p-4">
      <h4>Emojislider:</h4>
      <emoji-slider />
    </el-card>

    <CommitmentVisualBar
      :percents="valueList"
      foreground-color="#badaff"
      background-color="#bada55"></CommitmentVisualBar>
    <br />
    <input type="range" min="0" step="1" max="100" v-model="valueList[0]">{{valueList[0]}}<br />
    <input type="range" min="0" step="1" max="100" v-model="valueList[1]">{{valueList[1]}}<br />
    <input type="range" min="0" step="1" max="100" v-model="valueList[2]">{{valueList[2]}}<br />
    <input type="range" min="0" step="1" max="100" v-model="valueList[3]">{{valueList[3]}}<br />
    <br />

    <pre>JAN: {{ t('el.datepicker.months.jan') }}</pre>
    <!-- TODO: This should be replace with date-selector and timezone=null -->
    <el-date-picker
     v-model="value6"
     type="date"
     placeholder="Pick a day">
   </el-date-picker>

    <el-row>
      <el-button>Default</el-button>
      <el-button type="primary">Primary</el-button>
      <el-button type="success">Success</el-button>
      <el-button type="info">Info</el-button>
      <el-button type="warning">Warning</el-button>
      <el-button type="danger">Danger</el-button>
    </el-row>

    <div class="block">
      <span class="demonstration">Default value</span>
      <el-slider v-model="value1"></el-slider>
    </div>
    <div class="block">
      <span class="demonstration">Customized initial value</span>
      <el-slider v-model="value2"></el-slider>
    </div>
    <div class="block">
      <span class="demonstration">Hide Tooltip</span>
      <el-slider v-model="value3" :show-tooltip="false"></el-slider>
    </div>
    <div class="block">
      <span class="demonstration">Format Tooltip</span>
      <el-slider v-model="value4" :format-tooltip="formatTooltip"></el-slider>
    </div>
    <div class="block">
      <span class="demonstration">Disabled</span>
      <el-slider v-model="value5" disabled></el-slider>
    </div>
  </div>
</template>

<script>
import Locale from 'element-ui/src/mixins/locale';
import CommitmentVisualBar from '@/components/Elements/CommitmentVisualBar'

export default {
  data() {
    return {
      test_time1: '12:45',
      test_time2: new Date(2016, 9, 10, 12, 45), // '12:45',
      test_time3: '1:45 AM',
      test_time4: {
         HH: '03',
         mm: '10',
         a: 'am'
      },
      valueList: [10, 40, 20, 60],
      value1: 0,
      value2: 50,
      value3: 36,
      value4: 48,
      value5: 42,
      value6: null
    }
  },
  mixins: [Locale],
  methods: {
    formatTooltip(val) {
      return val / 100;
    }
  },
  components: {
    CommitmentVisualBar
  }
}
</script>

<style>
.gp-custom-time-picker .el-time-spinner__item {
  font-size: 20px;
}
</style>
